import ProfissionaisPecCnes from '../pages/ProfissionaisPecCnes/Index'

export default [
  {
    path: '/profissionais-pec-cnes',
    component: ProfissionaisPecCnes,
  },
]
